import * as React from "react";
import { forwardRef } from "react";
const SvgPin = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 24, viewBox: "0 0 17 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.54024 0C13.2132 0 17 3.86302 17 8.63032C17 13.3976 8.78218 24 8.54024 24C8.21798 24 0 13.3971 0 8.63032C0 3.86312 3.86735 0 8.54024 0ZM8.54024 5.42462C10.1516 5.42462 11.4406 6.73965 11.4406 8.38346C11.4406 10.0273 10.1516 11.3423 8.54024 11.3423C6.92892 11.3423 5.63989 10.0273 5.63989 8.38346C5.63989 6.73965 6.92892 5.42462 8.54024 5.42462Z", style: {
  fill: "var(--bk-control, #5777DA)"
} }));
const ForwardRef = forwardRef(SvgPin);
export { ForwardRef as ReactComponent };
